import { render, staticRenderFns } from "./crown-gardens.vue?vue&type=template&id=af2bca42&"
import script from "./crown-gardens.vue?vue&type=script&lang=js&"
export * from "./crown-gardens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports